import { render, staticRenderFns } from "./choosepeol.vue?vue&type=template&id=fcf06fb0&scoped=true"
import script from "./choosepeol.vue?vue&type=script&lang=js"
export * from "./choosepeol.vue?vue&type=script&lang=js"
import style0 from "./choosepeol.vue?vue&type=style&index=0&id=fcf06fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf06fb0",
  null
  
)

export default component.exports